import { keys } from './keys';

export const es = {
  [keys.buttonAddFile]: 'Añadir archivo',
};
